(function () {
  if (window.__comparisonLinkBound) return;
  window.__comparisonLinkBound = true;

  document.addEventListener('click', function (event) {
    var link = event.target.closest && event.target.closest('a[data-comparison-link]');
    if (!link || event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;

    var container = document.getElementById((link.getAttribute('href') || '').slice(1));
    if (!container) return;

    var target = container.querySelector('[data-comparison-focus]') || container;
    if (!target.hasAttribute('tabindex')) target.setAttribute('tabindex', '-1');

    event.preventDefault();
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    container.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'start' });
    target.focus({ preventScroll: true });
    if (window.history && history.pushState && location.hash !== '#' + container.id) {
      history.pushState(null, '', '#' + container.id);
    }
  });
})();
